(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("sbRespLib"), require("mobx"), require("React"), require("sbRespUI"), require("mobxReact"));
	else if(typeof define === 'function' && define.amd)
		define("sb-responsive-scoreboard-block", ["sbRespLib", "mobx", "React", "sbRespUI", "mobxReact"], factory);
	else if(typeof exports === 'object')
		exports["sb-responsive-scoreboard-block"] = factory(require("sbRespLib"), require("mobx"), require("React"), require("sbRespUI"), require("mobxReact"));
	else
		root["sb-responsive-scoreboard-block"] = factory(root["sbRespLib"], root["mobx"], root["React"], root["sbRespUI"], root["mobxReact"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__14__) {
return 